import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const team = [
  { name: 'Youssef El Amrani', role: 'Founder & Lead Guide', emoji: '👨‍💼', bio: 'Born and raised in Marrakech, Youssef has been guiding travelers through Morocco for over 15 years. Licensed guide, Arabic/English/French speaker.' },
  { name: 'Fatima Benali', role: 'Operations Manager', emoji: '👩‍💼', bio: 'Fatima ensures every booking goes smoothly and every guest receives the warmest Moroccan welcome. Speaks French, Arabic, and Spanish.' },
  { name: 'Karim Tahiri', role: 'Desert & Atlas Guide', emoji: '🧗', bio: 'Karim is our Atlas Mountains and Agafay desert specialist. Former mountain trekker, now guiding day trips to the most beautiful landscapes in Morocco.' },
  { name: 'Amina Ouazzani', role: 'Guest Experience', emoji: '⭐', bio: 'Amina handles all guest communications, reviews, and post-tour follow-up. She makes sure every traveler leaves Morocco with a smile.' },
];

const values = [
  { icon: '🌍', title: 'Authentic Experiences', text: 'We show you the real Morocco — not a tourist version of it. We bring you to local homes, hidden souks, and places most visitors never see.' },
  { icon: '🤝', title: 'Community First', text: 'We partner with local Berber families, artisans, and small businesses. Every tour you book directly supports the communities you visit.' },
  { icon: '🌱', title: 'Responsible Tourism', text: 'We keep group sizes small, minimize our environmental impact, and educate travelers about Moroccan culture and customs.' },
  { icon: '💯', title: 'Quality Guaranteed', text: 'Every tour in our collection has been personally tested by our team. If it\'s not exceptional, it\'s not in our catalog.' },
];

export default function About() {
  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="section-tag">Our Story</div>
          <h1>About Marrakech Best Activities</h1>
          <p>Local experts sharing the magic of Morocco since 2012</p>
        </div>
      </div>

      {/* Story section */}
      <section className="section section-white">
        <div className="container about-story">
          <div className="about-story__text">
            <span className="section-tag">Who We Are</span>
            <h2 className="section-title" style={{ textAlign: 'left' }}>Born in Marrakech,<br /><em>Built for Travelers</em></h2>
            <p>We offer a wide range of authentic Morocco experiences — from guided day trips to the Atlas Mountains and Agafay Desert, to cultural tours through Marrakech's historic medina, coastal escapes to Essaouira, and thrilling activities like hot air ballooning, quad biking, and camel riding.</p>
            <p style={{ marginTop: 16 }}>Every experience is led by licensed local guides who bring deep knowledge and genuine passion to every tour. We specialize in small-group and private tours to ensure every traveler gets a personal, unforgettable experience.</p>
            <p style={{ marginTop: 16 }}>Whether you're looking for adventure, culture, relaxation, or all three — we have the perfect experience waiting for you in Morocco.</p>
            <div className="about-stats">
              {[['5,000+', 'Happy travelers'], ['12+', 'Years experience'], ['23', 'Unique experiences'], ['4.9★', 'Average rating']].map(([n, l]) => (
                <div key={l} className="about-stat">
                  <div className="about-stat__num">{n}</div>
                  <div className="about-stat__label">{l}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="about-story__visual">
            <div className="about-visual-card">
              <img
                src="https://www.image2url.com/r2/default/images/1777128435495-e7e28c36-d73b-4780-afbf-672579576f88.png"
                alt="Marrakech Best Activities"
                style={{ width: '100%', maxWidth: 220, objectFit: 'contain' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Our Values</span>
            <h2 className="section-title">What We Stand For</h2>
          </div>
          <div className="grid-4">
            {values.map(v => (
              <div key={v.title} className="value-card">
                <div className="value-card__icon">{v.icon}</div>
                <h3 className="value-card__title">{v.title}</h3>
                <p className="value-card__text">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section section-dark">
        <div className="container" style={{ textAlign: 'center' }}>
          <span className="section-tag">Ready to Explore?</span>
          <h2 className="section-title" style={{ color: 'var(--cream)', marginTop: 8 }}>Start Your Morocco Adventure</h2>
          <p className="section-subtitle" style={{ color: 'var(--muted)', marginBottom: 32 }}>Browse our tours and activities, or WhatsApp us to build your perfect Morocco itinerary.</p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/tours" className="btn btn-primary">Explore Tours</Link>
            <Link to="/contact" className="btn btn-outline">Contact Us</Link>
          </div>
        </div>
      </section>
    </>
  );
}
